import React, { useContext } from 'react'

import ThemeContext from 'src/components/system_wide/theme_context'
import useWindowSize from 'src/components/hooks/use_window_size'

import NavLogo from './nav_logo'
import NavContent from './nav_content'
import navigation from 'src/components/layout/menu_items'

const Navigation = () => {
  const configContext = useContext(ThemeContext)
  const { collapseMenu } = configContext.state
  const windowSize = useWindowSize()

  let navClass = ['pcoded-navbar']

  navClass = [...navClass]

  if (windowSize.width < 992 && collapseMenu) {
    navClass = [...navClass, 'mob-open']
  } else if (collapseMenu) {
    navClass = [...navClass, 'navbar-collapsed']
  }

  let navBarClass = ['navbar-wrapper']

  let navContent = (
    <div className={navBarClass.join(' ')}>
      <NavLogo />
      <NavContent navigation={navigation.items} />
    </div>
  )
  if (windowSize.width < 992) {
    navContent = (
      <div className="navbar-wrapper">
        <NavLogo />
        <NavContent navigation={navigation.items} />
      </div>
    )
  }
  return (
    <React.Fragment>
      <nav className={navClass.join(' ')}>{navContent}</nav>
    </React.Fragment>
  )
}

export default Navigation
